import React, { useEffect, useState } from "react";
import { Routes, Route, useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import WorkspaceService from "../service/workspace";
import MyWorkspace from "../component/MyWorkspace";
import WorkspaceDetail from "../component/MyWorkspace/Detail";
import ImportWorkspace from "../component/MyWorkspace/WorkspaceConfiguration/ImportWorkspace";
import ExportWorkspace from "../component/MyWorkspace/WorkspaceConfiguration/ExportWorkspace";
import LoadData from "../component/MyWorkspace/LoadData/index";
import DataConnection from "../component/MyWorkspace/DataConnections/Index";
import ScheduledJobs from "../component/MyWorkspace/scheduledJobs/index";
import DataPipeline from "../component/MyWorkspace/scheduledJobs/DataPipeline";
import DataLoadScheduler from "../component/MyWorkspace/scheduledJobs/DataModeling/DataLoad/DataLoadScheduler";
import DataQualityScheduler from "../component/MyWorkspace/scheduledJobs/DataModeling/DataQuality/DataQualityScheduler";
import DatExchangeScheduler from "../component/MyWorkspace/scheduledJobs/DataExchange/DataExchangeScheduler";
import ConfigCompare from "../component/MyWorkspace/ApplyToDataWarehouse/ConfigCompare";
import DataSource from "../component/MyWorkspace/DataModeling/DataSource";
import AddDataSource from "../component/MyWorkspace/DataModeling/DataSource/EditDataSource/AddDataSource";
import Entity from "../component/MyWorkspace/DataModeling/Entity";
import AddEntity from "../component/MyWorkspace/DataModeling/Entity/EditEntity/AddEntity";
import SalesforceExplorer from "../component/MyWorkspace/SalesforceExplorer";
import SnowflakeExplorer from "../component/MyWorkspace/snowflakeExplorer";
import DataTransformScheduler from "../component/MyWorkspace/scheduledJobs/DataTransform/DataTransformSchedular";
import RoutingScheduler from "../component/MyWorkspace/scheduledJobs/Routing/RoutingSchedular";
import ManageSchema from "../component/MyWorkspace/ManageSchemas/ManageSchema";
import DataAnalytics from "../component/MyWorkspace/DataAnalytics";
import MachineLearning from "../component/MyWorkspace/MachineLearning";
import BusinessRules from "../component/BusinessRules/Index";
import DQM from "../component/DQM";
import MDMScheduler from "../component/MyWorkspace/scheduledJobs/DataModeling/MDMScheduler";
import DataDedupScheduler from "../component/MyWorkspace/scheduledJobs/DataModeling/DataDeduplication/DedupScheduler";
import Notification from "../component/MyWorkspace/scheduledJobs/Notification/index";
import ApplyToDataWarehouse from "../component/MyWorkspace/ApplyToDataWarehouse";
import AppHosting from "../component/MyWorkspace/AppHosting";
import AddApplication from "../component/MyWorkspace/AppHosting/AddApplication";
import Statistics from "../component/MyWorkspace/Statistics";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { setWorkspace } from "../store/actions/workspace";

import {
  navDatasets,
  navEntities,
  navScheduledJobs,
  navDataScience,
  navDataConnection,
  navDataExplorer,
  navQuickImport,
  navManageSchemas,
  navImportWorkspace,
  navExportWorkspace,
  navQualityDashboard,
  navDataAI,
  navMachineLearning,
  navAppHosting,
} from "../component/kmk/AppData";
import VeevaVaultExplorer from "../component/MyWorkspace/VeevaVaultExplorer";
import Notebook from "../component/MyWorkspace/scheduledJobs/Notebook/NotebookSchedular";
import PageSuspense from "../component/Common/PageSuspense";
import SummaryDashboard from "../component/DQM/SummaryDashboard";

const DataExplorer = React.lazy(() => import("../component/MyWorkspace/DataExplorer"));
const DataAI = React.lazy(() => import("../component/MyWorkspace/Chatbot"));

const Workspace = () => {
  const { Workspace_id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const workspace = new WorkspaceService();
    workspace
      .getWorkspaceDetail(Workspace_id)
      .then((result) => {
        const { data, success } = result;
        if (success) dispatch(setWorkspace(data));
        else navigate("/my-workspaces");
        setLoading(false);
      })
      .catch(() => navigate("/my-workspaces"));
    //adding navigate here will reload on every navigation
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Workspace_id, dispatch]);

  if (loading)
    return (
      <Backdrop sx={{ backgroundColor: "transparent", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
        <CircularProgress color="primary" />
      </Backdrop>
    );

  return (
    <Routes>
      <Route path="/" element={<WorkspaceDetail />} />
      <Route path={`/${navImportWorkspace.link}`} element={<ImportWorkspace />} />
      <Route path={`/${navExportWorkspace.link}`} element={<ExportWorkspace />} />
      <Route path={`/${navQuickImport.link}`} element={<LoadData />} />
      <Route path={`/${navDataConnection.link}`} element={<DataConnection />} />
      <Route path={`/${navDataConnection.link}/:Stage_id/salesforce-explorer`} element={<SalesforceExplorer />} />
      <Route path={`/${navDataConnection.link}/:Stage_id/veevavault-explorer`} element={<VeevaVaultExplorer />} />
      <Route path={`/${navDataConnection.link}/:Stage_id/snowflake-explorer`} element={<SnowflakeExplorer />} />
      <Route path={`/${navScheduledJobs.link}`} element={<ScheduledJobs />} />
      <Route path={`/${navScheduledJobs.link}/data-pipeline/add`} element={<DataPipeline />} />
      <Route path={`/${navScheduledJobs.link}/data-pipeline/:DataPipeline_id`} element={<DataPipeline />} />
      <Route path={`/${navScheduledJobs.link}/data-load/:Job_id`} element={<DataLoadScheduler />} />
      <Route path={`/${navScheduledJobs.link}/data-load`} element={<DataLoadScheduler />} />
      <Route path={`/${navScheduledJobs.link}/mdm/:Job_id`} element={<MDMScheduler />} />
      <Route path={`/${navScheduledJobs.link}/mdm`} element={<MDMScheduler />} />
      <Route path={`/${navScheduledJobs.link}/data-quality`} element={<DataQualityScheduler />} />
      <Route path={`/${navScheduledJobs.link}/data-quality/:Job_id`} element={<DataQualityScheduler />} />
      <Route path={`/${navScheduledJobs.link}/data-exchange/:Job_id`} element={<DatExchangeScheduler />} />
      <Route path={`/${navScheduledJobs.link}/data-exchange`} element={<DatExchangeScheduler />} />
      <Route path={`/${navScheduledJobs.link}/data-transform/:Job_id`} element={<DataTransformScheduler />} />
      <Route path={`/${navScheduledJobs.link}/data-transform`} element={<DataTransformScheduler />} />
      <Route path={`/${navScheduledJobs.link}/routing/:Job_id`} element={<RoutingScheduler />} />
      <Route path={`/${navScheduledJobs.link}/routing`} element={<RoutingScheduler />} />
      <Route path={`/${navScheduledJobs.link}/notebook/:Job_id`} element={<Notebook />} />
      <Route path={`/${navScheduledJobs.link}/notebook`} element={<Notebook />} />
      <Route path={`/${navScheduledJobs.link}/data-deduplication/:Job_id`} element={<DataDedupScheduler />} />
      <Route path={`/${navScheduledJobs.link}/data-deduplication`} element={<DataDedupScheduler />} />
      <Route path={`/${navScheduledJobs.link}/notification/:Job_id`} element={<Notification />} />
      <Route path={`/${navScheduledJobs.link}/notification`} element={<Notification />} />
      <Route path={`/:type/statistics`} element={<Statistics />} />
      <Route path={`/${navDatasets.link}`} element={<DataSource />} />
      <Route path={`/${navDatasets.link}/:dataSourceId`} element={<AddDataSource />} />
      <Route path={`/${navEntities.link}`} element={<Entity />} />
      <Route path={`/${navEntities.link}/add`} element={<AddEntity />} />
      <Route path={`/${navEntities.link}/:entityID`} element={<AddEntity />} />
      <Route path="/bussiness-rules" element={<BusinessRules />} />
      <Route
        path={`/${navDataExplorer.link}`}
        element={
          <PageSuspense>
            <DataExplorer />
          </PageSuspense>
        }
      />
      <Route path={`/${navManageSchemas.link}`} element={<ManageSchema />} />
      <Route path={`/${navDataScience.link}`} element={<DataAnalytics />} />
      <Route
        path={`/${navDataAI.link}`}
        element={
          <PageSuspense>
            <DataAI />
          </PageSuspense>
        }
      />
      <Route path={`/${navMachineLearning.link}`} element={<MachineLearning />} />
      <Route path={`/${navQualityDashboard.link}`} element={<DQM />} />
      <Route path={`/${navQualityDashboard.link}/summary`} element={<SummaryDashboard />} />
      <Route path={`/config`} element={<ApplyToDataWarehouse />} />
      <Route path="/config/compare" element={<ConfigCompare />} />
      <Route path={`/${navAppHosting.link}`} element={<AppHosting />} />
      <Route path={`/${navAppHosting.link}/:App_id`} element={<AddApplication />} />
    </Routes>
  );
};

const MyWorkspaceRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<MyWorkspace />} />
      <Route path="/:Workspace_id/*" element={<Workspace />} />
    </Routes>
  );
};

export default MyWorkspaceRoutes;
